import type { UserRole } from '@/types';

export const roleLabel = (role?: UserRole | string, long = false): string => {
  switch (role) {
    case 'SUPER_ADMIN':
      return long ? 'Administrator' : 'Admin';
    case 'PROJECT_MANAGER':
      return 'Project Manager';
    case 'RESOURCE':
      return 'Resource';
    default:
      return 'User';
  }
};

/** A user's role as a neutral chip. Roles aren't states, so they carry no color. */
const RoleTag = ({ role, long = false }: { role?: UserRole | string; long?: boolean }) => (
  <span className="tempo-chip is-plain">{roleLabel(role, long)}</span>
);

export default RoleTag;
